module.exports = __webpack_public_path__ + "img/user02.a015ef80.png";